module.exports = __webpack_public_path__ + "img/business.009be890.png";